import * as Html from "../../util/Html.ts";

Html.registerWidget('widget/specific/imdayindicator',{initDom})

function initDom(obj: HTMLElement): void {
  const className = obj.className;
  let next = obj.nextElementSibling as HTMLElement | null;

  // Parcourt les éléments suivants jusqu'à trouver un ayant la même classe
  while (next && !next.classList.contains(className)) {
    next = next.nextElementSibling as HTMLElement | null;
  }

  if (!next) return;

  if (next.textContent?.trim() === obj.textContent?.trim()) {
    next.remove();
  }
}